



import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModuleModal = ({ show, handleClose, moduleId, moduleData, addModule, editModule }) => {
    const [name, setName] = useState('');

    useEffect(() => {
        if (moduleData) {
            setName(moduleData.name); // Set the name from the selected module data
        } else {
            setName(''); // Reset for new module
        }
    }, [moduleData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const moduleData = { name };

        if (moduleId) {
            editModule(moduleId, moduleData); // Call edit function
        } else {
            addModule(moduleData); // Call add function
        }

        handleClose(); // Close modal after submit
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{moduleId ? 'Edit Module' : 'Add Module'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="moduleName" className="form-label">Module Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="moduleName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <Button variant="primary" type="submit">
                        {moduleId ? 'Update Module' : 'Add Module'}
                    </Button>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default ModuleModal;


